import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../../Services/axiosCommon";
import { useFormik } from "formik";
import { ToggleRight } from "lucide-react";
import { HeadingWithIcon } from "../../../../../Components/Utils/Settingheading";
import { Link } from "react-router-dom";
import ViewIcon from "../../../../../Components/Icons/ViewIcon";
import FormsApproveLayout from "../Layout";
import { useToast } from "../../../../../Components/Others/ToastServices";

function FormsInspectionApprove() {
  const toast = useToast();
  //   const [data, setData] = useState([])
  const [initialData, setInitialData] = useState([]);
  //   const { Oncancel, editData, isLoading } = UseEditData()

  function getData() {
    axiosInstance
      .get(`/form/all-forms/with-category`)
      .then((res) => {
        setData(res?.data?.data);
        setInitialData(JSON.parse(JSON.stringify(res?.data?.data))); // Deep copy for comparison
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getData();
  }, []);


  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleChange = (id) => {
    const updated = data.find((item) => item.label === id);
    let value = {
      isEnabled: !updated.enabled,
    };
    axiosInstance
      .put(`/form/edit-form-status/by-category/${id}`, value)
      .then((res) => {
        if (res.data?.status === true) {
          getData();
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
  };

  const handleToggleFormChange = (cat, id) => {
    let datas = data.find((item) => item.label === cat);
    const updated = datas?.formList.find((item) => item.id === id);
    let value = {
      isEnabled: !updated.enabled,
    };
    axiosInstance
      .put(`/form/edit-form-status/${id}`, value)
      .then((res) => {
        if (res.data?.status === true) {
          getData();
          toast.open({
            type: "success",
            message: "Success",
            description: res.data?.msg || "Created Successfully.",
          });
        } else if (res.data?.status === false && res.data?.error) {
          toast.open({
            type: "error",
            message: "Error",
            description: res.data.error || "Network error.",
          });
        } else {
          toast.open({
            type: "warning",
            message: "Warning",
            description: res.data?.msg || "Warning.",
          });
        }
      })
      .catch((err) => {
        toast.open({
          type: "error",
          message: "Error",
          description: "Network error.",
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      forms: data,
    },
    onSubmit: (values) => {
      setIsLoading(true);
      console.log("Submitted values:", data);
      // Simulate submission
      setTimeout(() => {
        setIsLoading(false);
        alert("Form submitted!");
      }, 1000);
    },
  });


  const formatName = (text) => {
    if (!text) return "-";
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
<FormsApproveLayout>
  <div className="w-full h-full mt-0.5">
    {/* Fixed header and form area (non-scrollable) */}
    <div className="w-full bg-white mx-auto p-2 rounded-md">
      <HeadingWithIcon icon={ToggleRight} title="Inspection Forms" />
      <form onSubmit={formik.handleSubmit} className="space-y-2">
        {/* SCROLLABLE TABLE AREA */}
        <div className="w-full h-[calc(100vh-250px)] overflow-y-auto border rounded-xl shadow-sm bg-white relative">
          <table className="w-full table-fixed min-w-full text-sm border-separate border-spacing-0">
            <thead className="sticky top-0 z-10 bg-gradient-to-r from-red-600 to-red-400 text-white shadow-sm">
              <tr>
                <th className="w-[60%] text-left py-3 px-4 font-semibold">Form</th>
                <th className="w-[20%] text-center py-3 px-4 font-semibold">Enable / Disable</th>
                <th className="w-[20%] text-left py-3 px-4 font-semibold">Action</th>
              </tr>
            </thead>
            <tbody>
              {data.map((value, index) => (
                <React.Fragment key={index}>
                  <tr className="even:bg-slate-50 odd:bg-white hover:bg-slate-100 transition-all duration-200">
                    <td className="py-3 px-4 text-left font-medium text-gray-700">{value.label}</td>
                    <td className="py-3 px-4 text-center">
                      <label className="inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={value.enabled}
                          onChange={() => handleToggleChange(value.label)}
                          className="sr-only peer"
                        />
                        <div className={`relative w-12 h-6 rounded-full transition-all duration-300 peer ${value.enabled ? "bg-baseColor-primary" : "bg-gray-300"}`}>
                          <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full transition-all duration-300 ${value.enabled ? "translate-x-6" : ""}`}></div>
                        </div>
                      </label>
                    </td>
                    <td className="py-3 px-4 text-left">
                      <Link
                        to={`/settings/formsApprove/inspection/viewInspection/1`}
                        state={{ data: value }}
                        className="inline-flex items-center gap-1 text-teal-700 hover:text-teal-900 transition"
                      >
                        <ViewIcon color="#048178" />
                        <span className="hidden md:inline">View</span>
                      </Link>
                    </td>
                  </tr>

                  {value.formList?.map((form) => (
                    <tr
                      key={`${value.id}-${form.id}`}
                      className="even:bg-slate-50 odd:bg-white hover:bg-slate-100 transition-all duration-200"
                    >
                      <td className="py-3 px-8 pl-12 text-left text-gray-600">{formatName(form.name)}</td>
                      <td className="py-3 px-4 text-center">
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={form.enabled}
                            onChange={() => handleToggleFormChange(value.label, form?.id)}
                            className="sr-only peer"
                          />
                          <div className={`relative w-12 h-6 rounded-full transition-all duration-300 peer ${form.enabled ? "bg-baseColor-primary" : "bg-gray-300"}`}>
                            <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full transition-all duration-300 ${form.enabled ? "translate-x-6" : ""}`}></div>
                          </div>
                        </label>
                      </td>
                      <td className="py-3 px-4 text-left">
                        <Link
                          to={`/settings/formsApprove/survey/viewFormSur/${form?.id}`}
                          state={{ data: data }}
                          className="inline-flex items-center gap-1 text-teal-700 hover:text-teal-900 transition"
                        >
                          <ViewIcon color="#048178" />
                          <span className="hidden md:inline">View</span>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </form>
    </div>
  </div>
</FormsApproveLayout>

  );
}

export default FormsInspectionApprove;
